export default __webpack_public_path__ + "ae7da919c20ea0d0e6eb3f153b7e34bd.svg";